import { ForgottenPasswordsApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from './apiConfigs'

export const forgottenPasswordsClient = new ForgottenPasswordsApi(ecomConfiguration)
